<svg
  width="32"
  height="32"
  viewBox="0 0 32 32"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <rect x="4" y="4" width="6" height="6" rx="0.5" fill="currentColor" />
  <rect x="4" y="13" width="6" height="6" rx="0.5" fill="currentColor" />
  <rect x="4" y="22" width="6" height="6" rx="0.5" fill="currentColor" />
  <rect x="13" y="4" width="6" height="6" rx="0.5" fill="currentColor" />
  <rect x="13" y="13" width="6" height="6" rx="0.5" fill="currentColor" />
  <rect x="13" y="22" width="6" height="6" rx="0.5" fill="currentColor" />
  <rect x="22" y="4" width="6" height="6" rx="0.5" fill="currentColor" />
  <rect x="22" y="13" width="6" height="6" rx="0.5" fill="currentColor" />
  <rect x="22" y="22" width="6" height="6" rx="0.5" fill="currentColor" />
</svg>
